import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { UserShortDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Return = {
  isErrorGettingUsersShort: boolean;
  isGettingUsersShort: boolean;
  usersShort: UserShortDto[];
};

export const useGetUsersShort = (): Return => {
  const { usersApi } = useApiClient();

  const { data, isError, isPending } = useQuery<UserShortDto[]>({
    queryFn: async () => {
      const res = await usersApi.getUsersShort();
      return res.data;
    },
    queryKey: [QueryKeyEnum.USERS.SHORT],
  });
  return {
    isErrorGettingUsersShort: isError,
    isGettingUsersShort: isPending,
    usersShort: data ?? [],
  };
};
